var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","text-align":"left"}},[_c('BarChart',{staticStyle:{"width":"100%","margin-top":"2px"},style:({ height: `${_vm.height}px`}),attrs:{"list":_vm.dataset,"tooltip-fn":_vm.legend ? _vm.getTooltip : null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }